// If restore in Freespin (Not on the first freespin), the Intro will do the restore work but not show.
// When restore on the first freespin (the round winning Freespin), show the Intro.


import {IScreenConfig} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {FreespinIntroController} from "@nolimitcity/slot-game/bin/game/screen/freespinintro/FreespinIntroController";
import {TimelineLite} from "gsap";
import {Tesla} from "../Tesla";
import {TeslaSoundConfig} from "../TeslaSoundConfig";
import {TeslaFreeSpinIntroScreenView} from "./TeslaFreeSpinIntroScreenView";

export class TeslaFreeSpinIntroController extends FreespinIntroController {

    constructor(config:IScreenConfig, tweakEnabled?:boolean) {
        super(config, tweakEnabled);
    }

    // protected show():boolean {
    //     let timer:CountDownTimer = Tesla.freespinScreenAnimation.timer;
    //     (<TeslaFreeSpinIntroScreenView>this._view).setTimer(timer);
    //     (<TeslaFreeSpinIntroScreenView>this._view).setTimerCompleteCallback(() => this.finish());
    //
    //     return super.show();
    // }

    protected finish():void {
        // (<TeslaFreeSpinIntroScreenView>this._view).setTimerCompleteCallback(() => {});
        this.stopSound();
        this.playSound();
        (<TeslaFreeSpinIntroScreenView>this._view).hideButton();
        // This will turn off Autoplay if in restricted jurisdiction
        if(SlotGame.autoPlay.turnOffAutoplayOnBonus) {
            SlotGame.autoPlay.turnOffAutoplayOnBonus();
        }

        const tl:TimelineLite = new TimelineLite();
        if(this._isRestoreFreespin && !this._isFreespinWon) {
            tl.add(Tesla.wildCollectIndicator.getIntro(true));
            tl.add(Tesla.reelFrame.getFreespinPostIntroAnimation(true));

        } else {
            tl.add((<TeslaFreeSpinIntroScreenView>this._view).getHideIntroAnimation());
            tl.add(Tesla.wildCollectIndicator.getIntro());
            tl.add(Tesla.reelFrame.getFreespinPostIntroAnimation());
        }
        tl.add(() => super.finish());
    }

    private playSound():void {
        SlotGame.sound.playAmbience(TeslaSoundConfig.instance.FREESPIN_BG_MUSIC);
        SlotGame.sound.fadeAmbience(1.0, 0);
    }

    private stopSound():void {
        SlotGame.sound.fadeAmbience(0, 0);
    }
}